export default __webpack_public_path__ + "static/media/guard.10daeba9.svg";